/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../messageboxconfig.ts" />
/// <reference path="modaldialogcontrollerbase.ts" />

module App.Common.Controllers {
    'use strict';

    class MessageBoxController extends Controllers.ModalDialogControllerBase {

        public static $inject = ['$injector', '$uibModalInstance', 'config', 'modalConfig', '$uibModalStack'];
        constructor(
            $injector: angular.auto.IInjectorService,
            $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public config: MessageBoxConfig,
            modalConfig: ModalDialogConfig,
            $uibModalStack: angular.ui.bootstrap.IModalStackService) {
            super($injector, $uibModalInstance, modalConfig, $uibModalStack);
        }

        public initialize(): angular.IPromise<any> {
            return this.$q.resolve();
        }

        public mainFormName(): any {
            return 'messageBoxForm';
        }

        public selectOutcome(outcome: DialogOutcome) {
            if (outcome.isCancel) {
                this.dismiss(outcome);
            } else {
                super.close(outcome);
            }
        }

    }

    angular
        .module('app.common.controllers')
        .controller('app.common.controllers.messageBoxController', MessageBoxController);
}